import React from 'react';

import useRestBlocks from '@/hooks/useRestBlocks';
import { useArticle } from '@/modules/corporate/modules/article/articleContext';

import Editor from './Editor';
import { EditorContainerProps } from './types';

const EditorContainer: React.FC<EditorContainerProps> = (props) => {
  const {
    editorContainerRef,
    bottomRef,
    bannerRef,
    setHeaderState,
    setLessonDurationLeft,
    HeaderComponent,
    FooterComponent,
    onScroll,
  } = props;
  const {
    article: { id: articleId },
    articleContent: {
      id: articleContentId,
      lessonPageId: articleContentLessonPageId,
      customDuration: articleContentCustomDuration,
    },
    isPreviewing,
  } = useArticle();

  const { data: editorDoc, loading: fetchingBlocks } = useRestBlocks(
    articleContentLessonPageId,
    articleId,
  );

  return (
    <Editor
      FooterComponent={FooterComponent}
      HeaderComponent={HeaderComponent}
      articleContentCustomDuration={articleContentCustomDuration}
      articleContentId={articleContentId ?? ''}
      articleContentLessonPageId={articleContentLessonPageId}
      articleId={articleId}
      bannerRef={bannerRef}
      bottomRef={bottomRef}
      editorContainerRef={editorContainerRef}
      editorDoc={editorDoc}
      fetchingBlocks={fetchingBlocks}
      isPreviewing={isPreviewing}
      setHeaderState={setHeaderState}
      setLessonDurationLeft={setLessonDurationLeft}
      onScroll={onScroll}
    />
  );
};

export default React.memo(EditorContainer);
